import { RefDate, Ref, RefNumber, RefString } from "@tblabs/truffle";
import { PriceFactorMode } from "./PriceFactorMode";
import { RawPriceFactor } from "./RawPriceFactor";


export class PriceFactor
{
    public Start = new RefDate();
    public End = new RefDate();
    public Mode = new Ref<PriceFactorMode>(PriceFactorMode.Multiply);
    public Value = new RefNumber(1);
    public Info = new RefString("");

    constructor(raw?: Partial<RawPriceFactor>)
    {
        this.Start.value = new Date(raw?.Start ?? 0);
        this.End.value = new Date(raw?.End ?? 0);
        this.Mode.value = raw?.Mode || PriceFactorMode.Multiply;
        this.Value.value = raw?.Value || 1;
        this.Info.value = raw?.Info || "";
    }
}
